// Time-off request types and yearly allowances (per employee, per calendar year).
// Mirrors the mobile app's src/utils/timeOff.js — keep the two in sync.
export const TIME_OFF_TYPES = {
  sick: { label: 'Sick day', plural: 'sick days', limit: 10 },
  vacation: { label: 'Vacation', plural: 'vacation days', limit: 14 },
};

// Per-company yearly allowances live in settings/{companyId}.timeOffLimits
// (e.g. { sick: 8, vacation: 20 }). Anything missing or invalid
// falls back to the defaults above.
export const getLimits = (settingsData) => {
  const custom = settingsData?.timeOffLimits || {};
  const limits = {};
  for (const key of Object.keys(TIME_OFF_TYPES)) {
    const v = custom[key];
    limits[key] = typeof v === 'number' && v >= 0 ? Math.floor(v) : TIME_OFF_TYPES[key].limit;
  }
  return limits;
};

// Days already used (approved or still pending) for a type in a given year
export const usedDays = (requests, type, year) =>
  requests
    .filter(r =>
      r.type === type &&
      r.status !== 'denied' &&
      (r.startDate || '').startsWith(String(year))
    )
    .reduce((sum, r) => sum + (r.days || 0), 0);

export const typeLabel = (type) => TIME_OFF_TYPES[type]?.label || 'Time off';

export const formatRange = (startDate, endDate) => {
  const fmt = (s) => {
    const [y, m, d] = s.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString([], { month: 'short', day: 'numeric' });
  };
  if (!startDate) return '';
  return !endDate || endDate === startDate ? fmt(startDate) : `${fmt(startDate)} – ${fmt(endDate)}`;
};
